import { makeStyles } from '@material-ui/core/styles';

export const useSelectorStyles = makeStyles((theme) => ({
    formSelectorContainer: {
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(3),
    },
    selectorContainer: {
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(3),
    },
    selectorActions: {
        '& .MuiButton-text, .MuiButton-root': {
            marginRight: theme.spacing(1.5),
            marginBottom: theme.spacing(2),
        },

        '& .MuiIconButton-root': {
            '&.Mui-disabled': {
                '& svg': {
                    fill: theme.palette.grey[400],
                },
            },

            '&:hover': {
                background: 'none',
            },
        },
    },
    toolbarSpacer: {
        marginTop: theme.spacing(2),
    },
    browserLikeTooltip: {
        backgroundColor: '#fff',
        color: '#000',
        border: '1px solid #000',
        boxShadow: 'none',
        fontSize: '14px',
        lineHeight: 1.2,
        padding: theme.spacing(1, 1.5),
    },
}));
